import { api } from './client.js';

const root = '/products';

export const publicProductsApi = {
  list: (params) => api.get(root, { query: params }),
  get: (id) => api.get(`${root}/${id}`),
  plate: (id, params) => api.get(`${root}/${id}/plate`, { query: params }),
  compare: (ids) => api.get(`${root}/compare`, { query: { ids: ids.join(',') } }),
  alternatives: (id, params) => api.get(`${root}/${id}/alternatives`, { query: params })
};
